// extracted by mini-css-extract-plugin
export var footer = "_nh-0";
export var inherit = "_nh-1";
export var input = "_nh-2";
export var modalContent = "_nh-3";
export var quillEditor = "_nh-4";
export var subtitle = "_nh-5";